import Api     from '../../Utils/api';
import Reflux  from 'reflux';
import Actions from '../../actions';
import Utils from "../../Utils/Utility";

module.exports = Reflux.createStore({
    listenables:[Actions],

    // fetchParseConfig() {
    //     Api.fetchParseConfig();
    // },

    // getLiveItemDetailsMap() {
    //     if (this.data) {
    //         return this.data.liveItemIdItemDetailsMap;
    //     }
    // },

    getParentGroup(parentGroup) {
        if(!parentGroup) {
            return;
        }

        const parentGroupId = parentGroup.objectId;

        if(this.data && this.data.parentGroupsMap) {
            return this.data.parentGroupsMap[parentGroupId].groupDetail;
        }

        return null;
    },

    getGroupOnlineOrderingHours(groupDetail, orderTypeNew) {
        // get the order type here

        switch(orderTypeNew) {
            case 'PickUp':
                // code block
                return groupDetail.pickUpHours ? groupDetail.pickUpHours : groupDetail.openHours;
                // return "pickup";
                break;
            case 'Delivery':
                // code block
                return groupDetail.deliveryHours ? groupDetail.deliveryHours : groupDetail.openHours;
                // return "delivery";
                break;
            default:
                // code block
                return groupDetail.openHours;
        }
    },

    getGroupOpenHours(groupDetail, orderType){

        if (groupDetail) {

            let groupOpenHours = this.getGroupOnlineOrderingHours(groupDetail, orderType);

            if (groupOpenHours && groupOpenHours != null){

                return groupOpenHours;
            }
            else{
                const parentGroup = this.getParentGroup(groupDetail.parentGroup);

                if (parentGroup){
                    let parentGroupOpenHours = this.getGroupOnlineOrderingHours(parentGroup, orderType);
                    if (parentGroupOpenHours && parentGroupOpenHours != null){

                        return parentGroupOpenHours;
                    }
                }
            }


        }

        return null;

    },

    getAllData(activeLocationIndex, activeLocationId) {
        // console.log("main-store:" + "getAllData");
        return Api.getAllDataViaRest(activeLocationIndex, activeLocationId)
            .then((data) => {
                data["groupHierarchy"] = this.generateGroupHierarchy(data);
                return data;
            })
            .then((data) => {
                data["menuHierarchy"] = this.generateMenuHierarchy(data.groupHierarchy);
                this.data = data;
                return data;
            })
            .then((data) => {
                this.triggerChange();
            });
    },

    generateMenuHierarchy(groupHierarchy) {
        let menuArray = [];
        groupHierarchy.forEach(
            (groupObject) => {
                // check hideAfterHours is set or not
                // check current time exist in the group open hours
                let isGroupVisible = Utils.isGroupShownAfterHours(groupObject.groupDetail);

                if (isGroupVisible != false) {
                    let group = { groupName : groupObject.groupDetail.groupName, subGroups : null };
                    if (groupObject.subGroups && groupObject.subGroups.length > 0) {
                        let subGroupArray = [];
                        groupObject.subGroups.map((subGroup) => {
                            // check hideAfterHours is set or not
                            // check current time exist in the group open hours
                            let isSubGroupVisible = Utils.isGroupShownAfterHours(subGroup.groupDetail);

                            if (isSubGroupVisible != false) {
                                subGroupArray.push(subGroup.groupDetail.groupName);
                            }
                        });

                        group["subGroups"] = subGroupArray;
                    }
                    menuArray = menuArray.concat(group);
                }
            });
        return menuArray;
    },

    generateGroupHierarchy(data) {
        const groupDetails             = data.GroupDetails;
        const liveItemDetails              = data.ItemDetails;
        // console.log(JSON.stringify(itemDetails));

        // const liveItemDetails          = itemDetails.filter((itemDetail) => itemDetail.live);

        // console.log(JSON.stringify(liveItemDetails));

        const businessDetail           = data.BusinessDetail;
        let orderedGroupIds            = [];
        const sortedGroupedItemDetails = {};
        let groupHierarchy             = [];

        if (businessDetail) {

            // const groupIds = businessDetail.groupIds;
            // Groups Reorder functionality fixed:
            //     If multiple location enable then choose the groups Order from location table otherwise it choose in business table.

            var groupIds = [];

            if (businessDetail && businessDetail.bizConfig && businessDetail.bizConfig.isMenuSameForAllLocation == false) {
                groupIds = data.LocationDetail.groupIds;

            } else {
                groupIds = businessDetail.groupIds;
            }

            const liveItemIdItemDetailsMap = {};
            liveItemDetails.forEach((itemDetail) => {
                liveItemIdItemDetailsMap[itemDetail.objectId] = itemDetail;
            });

            data.liveItemIdItemDetailsMap = liveItemIdItemDetailsMap;

            const subGroupIdGroupDetailsMap = {};
            groupDetails
                .filter((groupDetail) => groupDetail.parentGroup || (!groupDetail.groupType && !groupDetail.parentGroup))
                .forEach((groupDetail) => subGroupIdGroupDetailsMap[groupDetail.objectId] = groupDetail);

            const orderedMerge = (prevOrderedArray = [], newArray = []) => {
                const newArrayData = prevOrderedArray.length > 0
                    ? prevOrderedArray.concat(newArray.filter((i) => prevOrderedArray.indexOf(i) == -1))
                    : newArray;

                // return the unique array data
                var filteredUniqueArray = newArrayData.filter(function(item, pos){
                    return newArrayData.indexOf(item)== pos;
                });

                return filteredUniqueArray;
            };

            const generateSortedItemDetails = (itemDetailsMap, groupDetail) => {

                const filteredItemIds = Object.keys(itemDetailsMap)
                    .filter((itemId) => {
                        const itemDetail = itemDetailsMap[itemId];
                        return itemDetail && itemDetail.groupDetailPointer.objectId == groupDetail.objectId;
                    });

                return orderedMerge(groupDetail.itemIds, filteredItemIds)
                    .map((itemId) => itemDetailsMap[itemId])
                    .filter(x => x);
            };

            const generateSortedGroupDetails = (groupDetailsMap, groupDetail) => {

                const filteredGroupIds = Object.keys(groupDetailsMap)
                    .filter((groupId) => {
                        const childGroup = groupDetailsMap[groupId];
                        return (
                            childGroup
                            && childGroup.parentGroup
                            && childGroup.parentGroup.objectId == groupDetail.objectId
                        ) ;
                    });

                return orderedMerge(groupDetail.childGroupIds, filteredGroupIds)
                    .map((groupId) => ({
                        groupType         : 'SIMPLE',
                        groupDetail       : groupDetailsMap[groupId],
                        sortedItemDetails : generateSortedItemDetails(liveItemIdItemDetailsMap, groupDetailsMap[groupId]),
                        parentGroupId     : groupDetail
                    }))
                    .filter((subGroupObj) => !subGroupObj.groupDetail.hide);

            };

            const parentGroups = {};
            groupDetails.filter((groupDetail) => (groupDetail.groupType === 'MENU' ) && !groupDetail.hide)
                .forEach((groupDetail) => {
                    parentGroups[groupDetail.objectId] = {
                        groupType     : 'MENU',
                        groupDetail   : groupDetail,
                        subGroups     : generateSortedGroupDetails(subGroupIdGroupDetailsMap, groupDetail),
                        parentGroupId : null
                    };
                });

            data.parentGroupsMap = parentGroups;

            Object.keys(subGroupIdGroupDetailsMap).forEach((subGroupId) => {
                let subGroupDetail = subGroupIdGroupDetailsMap[subGroupId];
                const subGroupObj = {
                    groupType         : 'SIMPLE',
                    groupDetail       : subGroupDetail,
                    sortedItemDetails : generateSortedItemDetails(liveItemIdItemDetailsMap, subGroupDetail),
                    parentGroupId     : null
                };

                if(!subGroupDetail.parentGroup && !subGroupDetail.hide) {
                    parentGroups[subGroupDetail.objectId] = subGroupObj;
                }
            });
            groupHierarchy =
                orderedMerge(groupIds, Object.keys(parentGroups))
                    .map((groupId) => parentGroups[groupId])
                    .filter(x => x);
        }

        return groupHierarchy;
    },

    // getGroupsItemsForLocation(locationDetail) {
    //     return Api.getGroupsItemsForLocationViaRest(locationDetail)
    //         .then((data) =>{
    //             this.data = data;
    //             this.triggerChange();
    //         });
    // },

    refreshLocation(locationDetail) {
        this.data.LocationDetail = locationDetail;
        this.triggerChange();
    },

    getBusinessDetail() {
        if(this.data) {
            return this.data.BusinessDetail;
        }
        return null;
    },

    refreshAllData(){
        if(this.data){
            this.triggerChange();
        }
    },

    getActiveLocation(){

        if (this.data.LocationDetail){
            return this.data.LocationDetail;
        }
        return null;
    },

    // check Location is enabled only for DineIn
    isLocationForDineInOnly() {
        let isDineIn = false;

        let activeLocation = this.getActiveLocation();

        if (activeLocation != null){
            let locationConfig = activeLocation.locationConfig;

            if (locationConfig && locationConfig != null) {

                if (locationConfig.dineInOnly && locationConfig.dineInOnly == true) {
                    return true;
                }
                else {
                    return false;
                }
            }
        }
        return isDineIn;
    },

    // check the item tax is configured or not
    isItemTaxConfigured() {
        let activeLocation = this.getActiveLocation();

        if (activeLocation && activeLocation.taxConfig) {
            return true;
        } else {
            return false;
        }
    },
    // get TaxConfig from locationDetail
    getItemTaxConfig() {

        let activeLocation = this.getActiveLocation();
        if (activeLocation && activeLocation.taxConfig) {
            return activeLocation.taxConfig;
        } else {
            return null;
        }
    },

    // check Menu is same for all location
    isMenuSameForAllLocationConfig() {
        let defaultMenu = false;

        let businessDetailConfig = this.getBusinessDetail();

        if (businessDetailConfig != null){
            let bizConfig = businessDetailConfig.bizConfig;

            if (Utils.isEmptyObj(bizConfig) || bizConfig == undefined){

               return defaultMenu;

            }
            else if (bizConfig && bizConfig.isMenuSameForAllLocation == true) {
                return true;
            }
            else {
                return defaultMenu;
            }
        }
        return defaultMenu;
    },
    // get app short name from mngAppConfig
    getAppShortName() {
        let defaultAppShortName = "merchants";

        let businessDetailConfig = this.getBusinessDetail();

        if (businessDetailConfig != null){
            let mngAppConfig = businessDetailConfig.mngAppConfig;
            let s3 = businessDetailConfig.s3;

            if (s3 && s3 != null) {
                return s3;
            }else if (mngAppConfig && mngAppConfig.shortAppName) {
                return mngAppConfig.shortAppName;
            }
            else {
                let legalName = businessDetailConfig.legalName;
                let name = Utils.removeSpecialCharsFromString(legalName);
                return name;
            }
        }
        return defaultAppShortName;
    },

    triggerChange(){
        this.trigger('change',this.data);
    }
});



// WEBPACK FOOTER //
// src/components/stores/main-store.jsx